import translations from './translations'

translations.add('es', {
    yourBrowserDoesNotSupportIFrames: 'El navegador no es compatible con iframes.'
})
